export const HEADER_TYPE = {
  DEFAULT: 'home', // 홈
  HOME: 'home',
  INTRODUCTION: 'introduction', // 소개
  ISSUANCE: 'issuance', // 발급
  INQUIRY: 'inquiry', // 조회
  POSCRM: 'poscrm', //POS/CRM
  STATISTICS: 'statistics', // 통계
  POSCRMSTATISTICS: 'poscrmstatistics', // POS CRM 통계
  MANAGEMENT: 'management', // 관리
  SUPPORT: 'support', // 지원
};

export const MENU_TYPE = {
  DEFAULT: 'home', // 기본

  HOME_0: 'home_0', // 예시

  INTRODUCTION_0: 'introduction_0',

  ISSUANCE_0: 'issuance_0',
  ISSUANCE_1: 'issuance_1',
  ISSUANCE_2: 'issuance_2',
  ISSUANCE_3: 'issuance_3',
  ISSUANCE_4: 'issuance_4',

  INQUIRY_0: 'inquiry_0',
  INQUIRY_1: 'inquiry_1',
  INQUIRY_2: 'inquiry_2',
  INQUIRY_3: 'inquiry_3',
  INQUIRY_4: 'inquiry_4',
  INQUIRY_5: 'inquiry_5',
  INQUIRY_6: 'inquiry_6',
  INQUIRY_7: 'inquiry_7',
  // INQUIRY_8: 'inquriy_8',

  INQUIRY_10: 'inquiry_10',
  INQUIRY_11: 'inquiry_11',
  INQUIRY_12: 'inquiry_12',
  INQUIRY_13: 'inquiry_13',

  POSCRM_0: 'poscrm_0',
  POSCRM_1: 'poscrm_1',
  POSCRM_2: 'poscrm_2',
  POSCRM_3: 'poscrm_3',

  STATISTICS_0: 'statistics_0',
  STATISTICS_1: 'statistics_1',
  STATISTICS_2: 'statistics_2',

  STATISTICS_10: 'statistics_10',
  STATISTICS_11: 'statistics_11',
  STATISTICS_12: 'statistics_12',

  POSCRMSTATISTICS_0: 'poscrmstatistics_0',
  POSCRMSTATISTICS_1: 'poscrmstatistics_1',
  POSCRMSTATISTICS_2: 'poscrmstatistics_2',

  MANAGEMENT_0: 'management_0',
  MANAGEMENT_1: 'management_1',
  MANAGEMENT_2: 'management_2',

  SUPPORT_0: 'support_0',
  SUPPORT_1: 'support_1',
};

export const MENU_LIST = {
  home: ['home'],
  account: [],
  compnay: [],
  policy: [],
  introduction: ['OVERVIEW'],
  issuance: [
    'Single Issuance',
    'Bulk',
    'Correction Issuance',
    'Copy Issuance',
    'E-Tax invoice setting',
  ],
  inquiry: [
    'Inquiry issuance List',
    'Inquiry by case',
    // 'Inquiry monthly/quarterly',
    'Inquiry of Corrected Invoice History',
    'Inquiry of VAT Return Monthly',
    'Inquiry of VAT Return Quarterly',
    'Inquiry E-mail history',
    'Hold issuance',
    'JWS Viewer',
  ],
  poscrm: [
    ['Inquiry POS/CRM issuance list'],
    'Inquiry POS/CRM by case',
    ['Inquiry POS/CRM history of corrected tax invoice'],
    'JWS Viewer',
  ],
  statistics: [
    'SUM',
    'Sales/purchase status by period',
    'Sales/purchase status by issue type',
  ],
  poscrmstatistics: [
    'SUM',
    'Sales/purchase status by period',
    'Sales/purchase status by issue type',
  ],
  management: [
    'Manage customer information',
    'Manage item infomation',
    ['Inquiry customer status (closure/temporary closure)'],
  ],
  support: ['ADVISORY', 'FAQ'],
};

export const MENU_INFO = {
  [MENU_TYPE.INTRODUCTION_0]: {
    mainURL: 'introduction/overview',
    containerClass: '',
  },
  [MENU_TYPE.ISSUANCE_0]: { mainURL: 'issuance/single', containerClass: '' },
  [MENU_TYPE.ISSUANCE_1]: { mainURL: 'issuance/mass', containerClass: '' },
  [MENU_TYPE.ISSUANCE_2]: {
    mainURL: 'issuance/correction',
    containerClass: '',
  },
  [MENU_TYPE.ISSUANCE_3]: { mainURL: 'issuance/copy', containerClass: '' },
  [MENU_TYPE.ISSUANCE_4]: { mainURL: 'issuance/setting', containerClass: '' },

  [MENU_TYPE.INQUIRY_0]: { mainURL: 'inquiry/issuance', containerClass: '' },
  [MENU_TYPE.INQUIRY_1]: { mainURL: 'inquiry/case', containerClass: '' },
  // [MENU_TYPE.INQUIRY_2]: { mainURL: 'inquiry/monthly', containerClass: '' },
  [MENU_TYPE.INQUIRY_2]: { mainURL: 'inquiry/history', containerClass: '' },
  [MENU_TYPE.INQUIRY_3]: {
    mainURL: 'inquiry/vat/return/monthly',
    containerClass: '',
  },
  [MENU_TYPE.INQUIRY_4]: {
    mainURL: 'inquiry/vat/return/quarterly',
    containerClass: '',
  },
  [MENU_TYPE.INQUIRY_5]: { mainURL: 'inquiry/email', containerClass: '' },
  [MENU_TYPE.INQUIRY_6]: { mainURL: 'inquiry/hold', containerClass: '' },
  [MENU_TYPE.INQUIRY_7]: { mainURL: 'inquiry/jws', containerClass: '' },

  [MENU_TYPE.INQUIRY_10]: { mainURL: 'poscrm/issuance', containerClass: '' },
  [MENU_TYPE.INQUIRY_11]: { mainURL: 'poscrm/case', containerClass: '' },
  [MENU_TYPE.INQUIRY_12]: { mainURL: 'poscrm/history', containerClass: '' },
  [MENU_TYPE.INQUIRY_13]: { mainURL: 'poscrm/jws', containerClass: '' },

  // [MENU_TYPE.POSCRM_0]: { mainURL: 'poscrm/issuance', containerClass: '' },
  // [MENU_TYPE.POSCRM_1]: { mainURL: 'poscrm/case', containerClass: '' },
  // [MENU_TYPE.POSCRM_2]: { mainURL: 'poscrm/history', containerClass: '' },
  // [MENU_TYPE.POSCRM_3]: { mainURL: 'poscrm/jws', containerClass: '' },

  [MENU_TYPE.STATISTICS_0]: { mainURL: 'statistics/sum', containerClass: '' },
  [MENU_TYPE.STATISTICS_1]: {
    mainURL: 'statistics/period',
    containerClass: '',
  },
  [MENU_TYPE.STATISTICS_2]: {
    mainURL: 'statistics/issuetype',
    containerClass: '',
  },

  [MENU_TYPE.STATISTICS_10]: {
    mainURL: 'poscrmstatistics/sum',
    containerClass: '',
  },
  [MENU_TYPE.STATISTICS_11]: {
    mainURL: 'poscrmstatistics/period',
    containerClass: '',
  },
  [MENU_TYPE.STATISTICS_12]: {
    mainURL: 'poscrmstatistics/issuetype',
    containerClass: '',
  },

  // [MENU_TYPE.POSCRMSTATISTICS_0]: {
  //   mainURL: 'poscrmstatistics/sum',
  //   containerClass: '',
  // },
  // [MENU_TYPE.POSCRMSTATISTICS_1]: {
  //   mainURL: 'poscrmstatistics/period',
  //   containerClass: '',
  // },
  // [MENU_TYPE.POSCRMSTATISTICS_2]: {
  //   mainURL: 'poscrmstatistics/issuetype',
  //   containerClass: '',
  // },

  [MENU_TYPE.MANAGEMENT_0]: {
    mainURL: 'management/client',
    containerClass: '',
  },

  [MENU_TYPE.MANAGEMENT_1]: { mainURL: 'management/item', containerClass: '' },
  [MENU_TYPE.MANAGEMENT_2]: {
    mainURL: 'management/client/status',
    containerClass: '',
  },

  [MENU_TYPE.SUPPORT_0]: { mainURL: 'support/advisory', containerClass: '' },
  [MENU_TYPE.SUPPORT_1]: { mainURL: 'support/faq', containerClass: '' },
};

export const BOARD_CODE = {
  EX_FAQ: {
    ['ALL']: { boardNo: [1, 2, 3, 4, 5, 6, 7] },
    ['GENERAL']: { boardNo: [1] },
    ['SIGNUP']: { boardNo: [2] },
    ['TRANSMISSION']: { boardNo: [3] },
    ['VERIFICATION']: { boardNo: [4] },
    ['ISSUANCE']: { boardNo: [5] },
    ['CORRECTION']: { boardNo: [6] },
    ['OTHERS']: { boardNo: [7] },
    ['BANNER']: { boardNo: [27] },
  },
};

export const SYSTEM_CODE = {
  EX: 'EX',
};

export const DIALOG_STATE = {
  open: false,
  useIcon: false,
  useIconType: 'warning',
  title: '',
  message: '',
  closeLabel: '',
  confirmLabel: '',
  onClose: () => {},
  onConfirm: () => {},
};
